export const overviewSubitems = [
  ['MRR-active-last-month-residential', 'MRR-active-last-month-commercial'],
  ['MRR-active-current-month-residential', 'MRR-active-current-month-commercial'],
  [],
  [],
  [],
  ['total-residential-premises', 'total-commercial-premises', 'total-mixed-premises'],
  ['ARPU-residential', 'ARPU-commercial'],
  [],
  ['canceled', 'awaitingCancelation', 'suspended', 'awaitingSuspension'],
  ['canceled', 'awaitingCancelation', 'suspended', 'awaitingSuspension'],
  ['canceled', 'awaitingCancelation', 'suspended', 'awaitingSuspension']
]
